export default {
  country_locale: 'da-DK',
  wia_contact_links: {
    BK: 'https://www.bauknecht.dk/Service/Kontakt-os',
    ID: 'https://www.indesit.dk/Indesit-Support/Kontaktformular',
    WP: 'https://www.whirlpool.dk/Support/Har-du-brug-for-hjaelp-1/Kontakt-os'
  },
  wia_title: 'Web-baseret portal for selvbetjening',
  wia_need_help: 'Jeg har brug for hjælp med',
  wia_model_name: 'Produktnavnet er',
  wia_back: '< ændre',
  wia_confirm: 'Bekræft',
  wia_issue_title: 'Hvad er dit problem',
  wia_issue_concern: 'Mit problem vedrører',
  wia_issue_specific: 'Angiv dit problem',
  wia_possible_solution: 'Mulige løsninger',
  wia_solved_issue: 'Er problemet løst',
  wia_closed: 'Luk X',
  wia_feedback_ok: 'Ja!',
  wia_find_another_solution: 'Find en anden løsning',
  wia_feedback_title: 'Vi er glade for at problemet er løst!',
  wia_feedback_text1: 'Besøg vores webbutik med specielle tilbud ',
  wia_feedback_text2: 'Lær mere om vores nyeste produkter',
  wia_smile_up_popup_text1: 'Læs mere om udvidede sikkerhedstjenester',
  wia_smile_down_popup_title: 'Har du brug for mere hjælp?',
  wia_smile_down_popup_text1: 'Gå til næste trin',
  wia_smile_down_popup_or_text: 'eller',
  wia_smile_down_popup_text2: 'Book service',
  wia_need_more_help: 'Har du brug for mere hjælp?',
  wia_optional_label: '(valgfrit)',
  wia_no_solution: 'Desværre er der ingen enkle selvbetjeningsløsninger til dit problem. Klik venligst her for support.',
  wia_all_solution: 'Alle løsninger',
  wia_all_categories: 'Alle kategorier',
  wia_seo_l1_issue: 'Alle fejl pr. kategori',
  wia_seo_wp_country_name: 'DK',
  wia_seo_bk_country_name: 'DK',
  wia_seo_hp_country_name: 'DK',
  wia_seo_id_country_name: 'DK',
  wia_seo_wp_meta_title: 'Problem og løsninger',
  wia_seo_bk_meta_title: 'Problem og løsninger',
  wia_seo_hp_meta_title: 'Problem og løsninger',
  wia_seo_id_meta_title: 'Problem og løsninger',
  wia_seo_wp_meta_description_home: 'Fejlsøg produktet med Whirlpools tekniske online værktøj',
  wia_seo_bk_meta_description_home: 'Fejlsøg produktet med Bauknechts tekniske online værktøj',
  wia_seo_hp_meta_description_home: 'Fejlsøg produktet med Hotpoints tekniske online værktøj',
  wia_seo_id_meta_description_home: 'Fejlsøg produktet med Indesits tekniske online værktøj',
  wia_issue_search: 'Hvad er problemet',
  wia_issue_description: 'Beskriv kort hovedproblemet med dit produkt',
  wia_issue_placeholder: 'Eks: Lækker den vand',
  wia_issue_generic_macro_category: 'Generelt',
  wia_issue_no_results: 'Ingen resultater fundet!',
  wia_issue_search_label: 'Søg',
  wia_related_solution: 'Relaterede løsninger',
  wia_seo_wp_meta_description: 'Løs dit problem med produktet ved at klikke på Bekos tekniske online værktøj',
  wia_seo_bk_meta_description: 'Løs dit problem med produktet ved at klikke på Bauknechts tekniske online værktøj',
  wia_seo_hp_meta_description: 'Løs dit problem med produktet ved at klikke på Hotpoints tekniske online værktøj',
  wia_seo_id_meta_description: 'Løs dit problem med produktet ved at klikke på Indesits tekniske online værktøj'
}
